import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import ReactQuill, { Quill } from "react-quill";
import { doPortChange, get, post, put } from "helpers/api_helper";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import UploadFile from "components/CommonLayouts/UploadFiles";
import * as api from "../../../constants/api_constants";
import { charactersOnly, zipcode } from "helpers/validations/regex";
import { charactersWithSpaces } from "helpers/validations/regex";
import { identificationNumber } from "helpers/validations/regex";
import { showErrorToast, showSuccessToast } from "helpers/toastMessages";
import CustomAmountInput from "components/CustomInput/CustomAmountInput";
import { getAllCountries } from "helpers/utils/locationUtil";
import { formatToPascal } from "helpers/utils/nameUtils";

function AddReceivables() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [fetchedData, setFetchedData] = useState({});
  console.log("fetchedData",fetchedData);
  
  const [employees, setEmployees] = useState([]);
  const [countries, setCountries] = useState([{}]);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const fetchedCountries = await getAllCountries();

      const countriesWithLabelAndCurrency = fetchedCountries.map((country) => ({
        label: country.name,
        currency: country.currency,
      }));

      // Update the state with the processed data
      setCountries(countriesWithLabelAndCurrency);
    };

    fetchData();
  }, []);

  const employeeData = async () => {
    try {
      const response = await get(api.GET_ALL_EMPLOYEES_NAME_ID_MAIL);
      // console.log(response);
      const employeeResponse = response.map((item) => ({
        value: item.employeeId,
        label: `${item.firstName}  ${item.lastName}`,
        number: item.number,
        email: item.email,
        address: `${item.permanentAddress.city ?? ""} ${
          item.permanentAddress.province ?? ""
        } ${item.permanentAddress.country ?? ""} ${
          item.permanentAddress.zipCode ?? ""
        }`,
        department: item.department,
      }));
      const res = await get(api.GET_ALL_CUSTOMERS_ID_NAME_MAIL_CURRENCY);
      const customerResponse = res.map((item) => ({
        value: item.customerId,
        name: item.companyName,
        address: `${item.city} ${item.province} ${item.country} ${item.zipCode}`,
        primaryContact: item.primaryContactName,
      }));
      setCustomers(customerResponse);

      setEmployees(employeeResponse);
    } catch (error) {
      console.log("Error fetching employees data");
    }
  };

  const validationSchema = Yup.object({
    from: Yup.string().required("From is a required field"),
    name: Yup.string().test(
      "employee-name-validation", // Test name
      "Name is required",
      function (value) {
        const { from } = this.parent;

        if (["CUSTOMER", "EMPLOYEE", "OTHERS"].includes(from) && !value) {
          return false; // Validation fails if 'EMPLOYEE' is selected but 'name' is empty
        }
        return true; // Otherwise, no validation error
      }
    ),

    receivedAmount: Yup.string()
      .required("Received Amount is a required field")
      .matches(
        /^\d+(\.\d{1,2})?$/,
        "Received Amount must be a valid number with up to two decimal places"
      ),
    totalReceivableAmount: Yup.string()
      .required("Total Receivable Amount is a required field")
      .matches(
        /^\d+(\.\d{1,2})?$/,
        "Total Receivable Amount must be a valid number with up to two decimal places"
      ),
    status: Yup.string().required("Status is a required field"),
    purpose: Yup.string().required("Purpose is required"),
    transactionMode: Yup.string().required("Transaction Mode is required"),
    currency: Yup.string().required("Currency is required"),
  });

  useEffect(() => {
    employeeData();
    if (id) {
      fetchReceivablesData(id);
    }
  }, [id]);
  const fetchReceivablesData = async (id) => {
    try {
      const response = await get(api.GET_RECEIVABLE_BY_ID(id));

      const res = await get(api.GET_ALL_EMPLOYEES_NAME_ID_MAIL);
      const employeeResponse = res.map((item) => ({
        value: item.employeeId,
        label: `${item.firstName}  ${item.lastName}`,
        department: item.department,
      }));
      const receivablesData = response?.data;
      let temp = employeeResponse.find(
        (employee) => employee.label === receivablesData?.name
      );
      let department = temp?.department;

      const custData = await get(api.GET_ALL_CUSTOMERS_ID_NAME_MAIL_CURRENCY);
      const customerResponse = custData.map((item) => ({
        value: item.customerId,
        label: `${item.name} ${item.email}`,

        primaryContact: item.primaryContactName,
      }));
      // console.log("Customer Responcec",customerResponse);
     
      setFetchedData({
        from: receivablesData.field,
        name: receivablesData.name,
        department: formatToPascal(department),
        primaryContact: receivablesData.primaryContact,
        billingAddress: receivablesData.address,
        purpose: receivablesData.purpose,
        currency: receivablesData.currency,
        totalReceivableAmount: receivablesData.totalReceivableAmount,
        adjustmentAmount: receivablesData.adjustmentAmount,
        receivedAmount: parseFloat(receivablesData.receivedAmount),
        amountDue: receivablesData.amountDue,
        status: receivablesData.receivableStatus,
        transactionMode: receivablesData.transactionMode,
        transactionNumber: receivablesData.transactionNumber,
        invoiceDate: receivablesData.invoiceDate,
        invoiceNumber: receivablesData.invoiceNumber,
        notes: receivablesData.notes,

        // invoiceAmount: receivablesData.invoiceAmount,
        // description: receivablesData.description,
        // source: receivablesData.source,
        // receivedDate: receivablesData.receivedDate,
        // receivedAmountTillDate: receivablesData.receivedAmountTillDate,
        // balanceAmount: receivablesData.balanceAmount,
        // dueDate: receivablesData.dueDate,
      });


      console.log(fetchedData);
   
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: id
      ? fetchedData
      : {
          field: "",
          name: "",
          department: "",
          primaryContact: "",
          billingAddress: "",
          purpose: "",
          currency: "",
          totalReceivableAmount: "",
          adjustmentAmount: "",
          receivedAmount: "",
          amountDue: "",
          status: "",
          transactionMode: "",
          transactionNumber: "",
          invoiceDate: "",
          invoiceNumber: "",
          notes: "",

          // description: "",
          // source: "",
          // receivedDate: "",
          // invoiceAmount: "",
          // dueDate: "",
          // receivedAmountTillDate: "",
          // balanceAmount: "",
        },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      console.log("Submitting form...",values);

      try {
        const receivedData = {
          receivable: {
            field: values.from,
            name: values.name,
            department: values.department,
            primaryContact: values.primaryContact,
            address: values.billingAddress,
            purpose: values.purpose,
            currency: values.currency,
            totalReceivableAmount: parseFloat(values.totalReceivableAmount),
            adjustmentAmount: parseFloat(values.adjustmentAmount),
            receivedAmount: parseFloat(values.receivedAmount),
            amountDue: parseFloat(values.amountDue),
            receivableStatus: values.status,
            transactionMode: values.transactionMode || null,
            transactionNumber: values.transactionNumber,
            invoiceDate: values.invoiceDate,
            invoiceNumber: values.invoiceNumber,
            notes: values.notes,
          },
        };

        let response;
        if (id) {
          // console.log("Updating receivable with ID:", id);
          response = await put(api.UPDATE_RECEIVABLE_BY_ID(id), receivedData);
        } else {
          // console.log("Creating new receivable");
          response = await post(api.CREATE_RECEIVABLE, receivedData);
        }

        if (!response) {
          throw new Error("No response received from server");
        }

        if (response.success) {
          showSuccessToast("Receivable saved successfully!");
          setTimeout(() => navigate("/receivables"), 1500); // Delay navigation to show success message
        } else {
          throw new Error(response.message || "Request failed");
        }
      } catch (error) {
        console.error("Submission error:", error);
        showErrorToast(
          error.message || "Failed to save receivable. Please try again."
        );
      }
    },
  });

  // useEffect(() => {
  //   if (!id) {
  //     formik.setFieldValue("name", "");
  //     formik.setFieldValue("billingAddress", "");
  //     formik.setFieldValue("primaryContact", "");
  //   }
  // }, [formik.values.from]);

  // useEffect(() => {
  //   if (formik.values.from === "CUSTOMER") {
  //     let selectCustomer = customers.find(
  //       (customer) => customer.name === formik.values.name
  //     );
  //     if (selectCustomer) {
  //       formik.setFieldValue("billingAddress", selectCustomer.address || "");
  //       formik.setFieldValue("name", selectCustomer.name || "");
  //       formik.setFieldValue("primaryContact", selectCustomer.primaryContact || "");
  //     }
  //   }
  // }, [formik.values.name, formik.values.from]);

  // useEffect(() => {
  //   if (formik.values.from === "EMPLOYEE") {
  //     let selectedEmployee = employees.find(
  //       (employee) => employee.label === formik.values.name
  //     );
  //     if (selectedEmployee) {
  //       formik.setFieldValue("billingAddress", selectedEmployee.address || "");
  //       formik.setFieldValue("department", selectedEmployee.department || "");
  //       formik.setFieldValue("primaryContact", "");
  //     }
  //   }
  // }, [formik.values.name, formik.values.from]);

  // useEffect(() => {
  //   console.log("in useeffect 4")

  //   if (formik.values.from === "OTHERS" || formik.values.name === "") {
  //     formik.setFieldValue("billingAddress", "");
  //     formik.setFieldValue("department", "");
  //     formik.setFieldValue("primaryContact", "");
  //   }
  // }, [formik.values.from, formik.values.name]);

  // useEffect(() => {
  //   if (id) {
  //     console.log("in useeffect")
  //     formik.setFieldValue("name", fetchedData.name || "");
  //     formik.setFieldValue("billingAddress", fetchedData.billingAddress || "");
  //     formik.setFieldValue("from", fetchedData.from || "");
  //     formik.setFieldValue("department", "");
  //     formik.setFieldValue("primaryContact", fetchedData.primaryContact || "");
  //   }
  // }, [id]);

  const handleFrom = (e) => {
    formik.setFieldValue("from", e.target.value);
    // console.log(e.target.value);
    // console.log(formik.values.department);

    if (e.target.value) {
      formik.setFieldValue("name", "");
      formik.setFieldValue("billingAddress", "");
      formik.setFieldValue("primaryContact", "");
    }

    if (!id || e.target.value === "CUSTOMER") {
      formik.setFieldValue("department", "");
      formik.setFieldValue("primaryContact", "");
    }
  };

  const handleEmployeeName = (e) => {
    formik.setFieldValue("name", e.target.value);
    // console.log(e.target.value);

    let selectedEmployee = employees.find(
      (employee) => employee.label === e.target.value
    );

    if (selectedEmployee && formik.values.from === "EMPLOYEE") {
      formik.setFieldValue("billingAddress", selectedEmployee.address || "");
      formik.setFieldValue("department", selectedEmployee.department || "");
      formik.setFieldValue("primaryContact", fetchedData.primaryContact || "");
    } else {
      formik.setFieldValue("billingAddress", "");
      formik.setFieldValue("department", "");
    }
  };

  const handleCustomerName = (e) => {
    formik.setFieldValue("name", e.target.value);
    // console.log(e.target.value);

    let selectedCustomer = customers.find(
      (customer) => customer.name === e.target.value
    );
    if (selectedCustomer && formik.values.from === "CUSTOMER") {
      formik.setFieldValue("billingAddress", selectedCustomer.address || "");
      formik.setFieldValue(
        "primaryContact",
        selectedCustomer.primaryContact || ""
      );
    } else {
      formik.setFieldValue("billingAddress", "");
    }
  };

  const handleReceivableAmountChange = (e) => {
    formik.setFieldValue("totalReceivableAmount", e.target.value);
    // console.log(e.target.value);
    calculateDueAmount(
      e.target.value,
      formik.values.receivedAmount,
      formik.values.adjustmentAmount
    );
  };

  const handleReceivedAmountChange = (e) => {
    formik.setFieldValue("receivedAmount", e.target.value);
    // console.log("recevied Amount", e.target.value);
    calculateDueAmount(
      formik.values.totalReceivableAmount,
      e.target.value,
      formik.values.adjustmentAmount
    );
  };

  const handleAdjustmentAmountChange = (e) => {
    formik.setFieldValue("adjustmentAmount", e.target.value);
    // console.log(e.target.value);
    calculateDueAmount(
      formik.values.totalReceivableAmount,
      formik.values.receivedAmount,
      e.target.value
    );
  };

  const calculateDueAmount = (
    totalReceivableAmount,
    receivedAmount,
    adjustmentAmount
  ) => {
    const receivable = parseFloat(totalReceivableAmount) || 0;
    const received = parseFloat(receivedAmount) || 0;
    const adjustment = parseFloat(adjustmentAmount) || 0;

    const dueAmount = receivable - (received + adjustment);
    formik.setFieldValue("amountDue", dueAmount.toFixed(2));
  };

  return (
    <div className="page-content">
      <Container fluid={true} className="py-0 px-0">
        {id ? (
          <PageSubHeader
            heading={"Update Receivables"}
            routePath={"Home"}
            pageName={"Update Receivables"}
          />
        ) : (
          <PageSubHeader
            heading={"Add Receivables"}
            routePath={"Home"}
            pageName={"Add Receivables"}
          />
        )}

        <Row className="px-4 mx-0 my-3 ">
          <Col className="p-0 m-0" xs={12} md={12}>
            <Card>
              <CardBody>
                {/* <h4 className="card-title text-primary">Add Employee</h4> */}
                <Form
                  className="row g-3 needs-validation py-3"
                  onSubmit={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                ></Form>
                <Row className="card-group">
                  <Col xs={12} className="card-header">
                    <p className="form-header">Receivables Information</p>
                  </Col>
                  <Row className="card-group-body">
                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="from">
                          From
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="from"
                          type="select"
                          className="form-control"
                          id="from"
                          value={formik.values.from || ""}
                          onChange={handleFrom}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.from && formik.errors.from
                              ? true
                              : false
                          }
                        >
                          <option value="">Select</option>
                          <option value="CUSTOMER">Customer</option>
                          <option value="EMPLOYEE">Employee</option>
                          <option value="OTHERS">Others</option>
                        </Input>
                        {formik.touched.from && formik.errors.from ? (
                          <FormFeedback type="invalid">
                            {formik.errors.from}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    {/* conditional rendering the extra input field when paid to is vendor */}

                    {formik.values.from === "CUSTOMER" && (
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="name">Customer Name</Label>
                          <Input
                            name="name"
                            type="select"
                            className="form-control"
                            id="name"
                            value={formik.values.name || ""}
                            onChange={handleCustomerName}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.name && formik.errors.name
                                ? true
                                : false
                            }
                          >
                            <option value="">Select</option>
                            {customers.map((customer) => (
                              <option value={customer.name}>
                                {customer.name}
                              </option>
                            ))}
                            {/* Add vendor options here */}
                          </Input>
                          {formik.touched.name && formik.errors.name ? (
                            <FormFeedback type="invalid">
                              {formik.errors.name}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )}

                    {/*condiational rendering for the extra input when employee is selected */}
                    {formik.values.from === "EMPLOYEE" && (
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="name">Employee Name</Label>
                          <Input
                            name="name"
                            type="select"
                            className="form-control"
                            id="name"
                            value={formik.values.name || ""}
                            onChange={handleEmployeeName}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.name && formik.errors.name
                                ? true
                                : false
                            }
                          >
                            <option value="">Select</option>
                            {employees.map((employee) => (
                              <option value={employee.label}>
                                {employee.label}
                              </option>
                            ))}
                          </Input>
                          {formik.touched.name && formik.errors.name ? (
                            <FormFeedback type="invalid">
                              {formik.errors.name}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )}

                    {/* Conditionally render the extra input field when "OTHERS" is selected */}
                    {formik.values.from === "OTHERS" && (
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="name">
                            Name
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="name"
                            type="text"
                            className="form-control"
                            id="name"
                            value={formik.values.name || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.name && formik.errors.name
                                ? true
                                : false
                            }
                          />
                          {formik.touched.name && formik.errors.name ? (
                            <FormFeedback type="invalid">
                              {formik.errors.name}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )}

                    {(formik.values.from === "EMPLOYEE" ||
                      formik.values.from === "OTHERS") && (
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="department">Department</Label>
                          <Input
                            name="department"
                            type="text"
                            className="form-control"
                            id="department"
                            value={formik.values.department || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.department &&
                              formik.errors.department
                                ? true
                                : false
                            }
                            disabled={
                              formik.values.from === "EMPLOYEE" ? true : false
                            }
                          >
                            <option value="">Select Department</option>
                            <option value="FINANCE">Finance</option>
                            <option value="DEVELOPMENT">Development</option>
                            <option value="HR">HR</option>
                            <option value="MARKETING_SALES">
                              Marketing & Sales
                            </option>
                            <option value="SUPPORT">Support</option>
                            <option value="TESTING">Testing</option>
                            <option value="ADMIN">Admin</option>
                            <option value="OTHERS">Others</option>
                          </Input>
                          {formik.touched.department &&
                          formik.errors.department ? (
                            <FormFeedback type="invalid">
                              {formik.errors.department}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )}

                    {(formik.values.from === "CUSTOMER" ||
                      formik.values.from === "OTHERS") && (
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="primaryContact">
                            Primary Contact{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="primaryContact"
                            type="text"
                            className="form-control"
                            id="primaryContact"
                            value={formik.values.primaryContact || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={
                              formik.touched.primaryContact &&
                              formik.errors.primaryContact
                                ? true
                                : false
                            }
                            disabled={
                              formik.values.from === "CUSTOMER" ||
                              formik.values.from === "EMPLOYEE"
                                ? true
                                : false
                            }
                          />
                          {formik.touched.primaryContact &&
                          formik.errors.primaryContact ? (
                            <FormFeedback type="invalid">
                              {formik.errors.primaryContact}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )}

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="billingAddress">
                          Address <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="billingAddress"
                          type="textarea"
                          className="form-control"
                          id="billingAddress"
                          value={formik.values.billingAddress || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.billingAddress &&
                            formik.errors.billingAddress
                              ? true
                              : false
                          }
                          disabled={
                            formik.values.from === "CUSTOMER" ||
                            formik.values.from === "EMPLOYEE"
                              ? true
                              : false
                          }
                        />
                        {formik.touched.billingAddress &&
                        formik.errors.billingAddress ? (
                          <FormFeedback type="invalid">
                            {formik.errors.billingAddress}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="purpose">
                          Purpose <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="purpose"
                          type="select"
                          className="form-control"
                          id="purpose"
                          value={formik.values.purpose || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.purpose && formik.errors.purpose
                              ? true
                              : false
                          }
                        >
                          <option value="">Select Purpose</option>
                          <option value="ADVANCE_PAY_ROLL">
                            Advance Payroll
                          </option>
                          <option value="ATTORNEY_FEE">Attorney Fee</option>
                          <option value="VISA_FEE">Visa Fee</option>
                          <option value="PERSONAL_USE">Personal Use</option>
                          <option value="POSTAGE_FEE">Postage Fees</option>
                          <option value="MISC_FEE">Misc Fees</option>
                        </Input>
                        {formik.touched.purpose && formik.errors.purpose ? (
                          <FormFeedback type="invalid">
                            {formik.errors.purpose}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="currency">
                          Currency <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="currency"
                          type="select"
                          className="form-control"
                          id="currency"
                          value={formik.values.currency || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.currency && formik.errors.currency
                              ? true
                              : false
                          }
                        >
                          <option value="">Select currency</option>

                          {countries.map((country) => (
                            <option value={country.currency}>
                              {country.label} - {country.currency}
                            </option>
                          ))}
                        </Input>
                        {formik.touched.currency && formik.errors.currency ? (
                          <FormFeedback type="invalid">
                            {formik.errors.currency}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    {/* <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="totalReceivableAmount"
                        field="Total Receivable Amount"
                        type="text"
                        className=""
                        id="totalReceivableAmount"
                        onChange={handleReceivableAmountChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.totalReceivableAmount || ""}
                        invalid={
                          formik.touched.totalReceivableAmount &&
                          formik.errors.totalReceivableAmount
                            ? true
                            : false
                        }
                        mandatory="yes"
                      />
                    </Col> */}
                    <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="totalReceivableAmount"
                        field="Total Receivable Amount"
                        type="text"
                        className=""
                        id="totalReceivableAmount"
                        // onChange={formik.handleChange}
                        onChange={handleReceivableAmountChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.totalReceivableAmount || ""}
                        invalid={
                          formik.touched.totalReceivableAmount &&
                          formik.errors.totalReceivableAmount
                            ? true
                            : false
                        }
                        mandatory="yes"
                      />
                    </Col>

                    <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="receivedAmount"
                        field="Recevied Amount"
                        type="text"
                        className=""
                        id="receivedAmount"
                        // onChange={formik.handleChange}
                        onChange={handleReceivedAmountChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.receivedAmount || ""}
                        invalid={
                          formik.touched.receivedAmount &&
                          formik.errors.receivedAmount
                            ? true
                            : false
                        }
                        mandatory="yes"
                      />
                    </Col>

                    <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="adjustmentAmount"
                        field="Adjustment Amount"
                        type="text"
                        className=""
                        id="adjustmentAmount"
                        onChange={handleAdjustmentAmountChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.adjustmentAmount || ""}
                        invalid={
                          formik.touched.adjustmentAmount &&
                          formik.errors.adjustmentAmount
                            ? true
                            : false
                        }
                      />
                    </Col>

                    <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="amountDue"
                        field="Due Amount"
                        type="text"
                        className=""
                        id="amountDue"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.amountDue || ""}
                        invalid={
                          formik.touched.amountDue && formik.errors.amountDue
                            ? true
                            : false
                        }
                        disable={
                          formik.values.amountDue && formik.values.amountDue > 0
                            ? true
                            : false
                        }
                      />
                    </Col>

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="status">
                          Status <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="status"
                          type="select"
                          className="form-control"
                          id="status"
                          value={formik.values.status || ""}
                          onChange={formik.handleChange} // Handle formik change for select input
                        >
                          <option value="">Select status</option>
                          <option value="RECEIVED">Received</option>
                          <option value="PARTIALLY_RECEIVED">
                            Partially Received
                          </option>
                          <option value="DRAFT">Draft</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="transactionMode">
                          Transaction Mode
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="transactionMode"
                          type="select"
                          className="form-control"
                          id="transactionMode"
                          value={formik.values.transactionMode || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.transactionMode &&
                            formik.errors.transactionMode
                              ? true
                              : false
                          }
                        >
                          <option value="">Select Transaction Mode</option>
                          <option value="CHEQUE">Cheque</option>
                          <option value="BANK">Bank</option>
                          <option value="CASH">Cash</option>
                          <option value="CC">Credit/Debit</option>
                        </Input>
                        {formik.touched.transactionMode &&
                        formik.errors.transactionMode ? (
                          <FormFeedback type="invalid">
                            {formik.errors.transactionMode}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="transactionNumber">Transaction #</Label>
                        <Input
                          name="transactionNumber"
                          type="text"
                          className="form-control"
                          id="transactionNumber"
                          value={formik.values.transactionNumber || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.transactionNumber &&
                            formik.errors.transactionNumber
                              ? true
                              : false
                          }
                        />
                        {formik.touched.transactionNumber &&
                        formik.errors.transactionNumber ? (
                          <FormFeedback type="invalid">
                            {formik.errors.transactionNumber}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="description">Description</Label>
                        <Input
                          name="description"
                          type="textarea"
                          className="form-control"
                          id="description"
                          value={formik.values.description || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.description &&
                            formik.errors.description
                              ? true
                              : false
                          }
                        />
                        {formik.touched.description &&
                        formik.errors.description ? (
                          <FormFeedback type="invalid">
                            {formik.errors.description}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col> */}

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="source">Source</Label>
                        <Input
                          name="source"
                          type="text"
                          className="form-control"
                          id="source"
                          value={formik.values.source || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.source && formik.errors.source
                              ? true
                              : false
                          }
                        />
                        {formik.touched.source && formik.errors.source ? (
                          <FormFeedback type="invalid">
                            {formik.errors.source}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col> */}

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="receivedDate">
                          Received Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="receivedDate"
                          type="date"
                          className="form-control"
                          id="receivedDate"
                          value={formik.values.receivedDate || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.receivedDate &&
                            formik.errors.receivedDate
                              ? true
                              : false
                          }
                        />
                        {formik.touched.receivedDate &&
                        formik.errors.receivedDate ? (
                          <FormFeedback type="invalid">
                            {formik.errors.receivedDate}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col> */}

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="invoiceDate">Invoice Date</Label>
                        <Input
                          name="invoiceDate"
                          type="date"
                          className="form-control"
                          id="invoiceDate"
                          value={formik.values.invoiceDate || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.invoiceDate &&
                            formik.errors.invoiceDate
                              ? true
                              : false
                          }
                        />
                        {formik.touched.invoiceDate &&
                        formik.errors.invoiceDate ? (
                          <FormFeedback type="invalid">
                            {formik.errors.invoiceDate}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="invoiceNumber">Invoice #</Label>
                        <Input
                          name="invoiceNumber"
                          type="text"
                          className="form-control"
                          id="invoiceNumber"
                          value={formik.values.invoiceNumber || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.invoiceNumber &&
                            formik.errors.invoiceNumber
                              ? true
                              : false
                          }
                        />
                        {formik.touched.invoiceNumber &&
                        formik.errors.invoiceNumber ? (
                          <FormFeedback type="invalid">
                            {formik.errors.invoiceNumber}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>

                    {/* <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="invoiceAmount"
                        field="Invoice Amount"
                        type="text"
                        className=""
                        id="invoiceAmount"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.invoiceAmount || ""}
                        invalid={
                          formik.touched.invoiceAmount &&
                          formik.errors.invoiceAmount
                            ? true
                            : false
                        }
                      />
                    </Col> */}

                    {/* <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="dueDate">
                          Due Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="dueDate"
                          type="date"
                          className="form-control"
                          id="dueDate"
                          value={formik.values.dueDate || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.dueDate && formik.errors.dueDate
                              ? true
                              : false
                          }
                        />
                        {formik.touched.dueDate && formik.errors.dueDate ? (
                          <FormFeedback type="invalid">
                            {formik.errors.dueDate}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col> */}

                    {/* <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="receivedAmountTillDate"
                        field="Recevied Amount Till Date"
                        type="text"
                        className=""
                        id="amountDue"
                        onChange={handleReceivedAmountChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.receivedAmountTillDate || ""}
                        invalid={
                          formik.touched.receivedAmountTillDate &&
                          formik.errors.receivedAmountTillDate
                            ? true
                            : false
                        }
                        mandatory="yes"
                      />
                    </Col> */}

                    {/* <Col md="4">
                      <CustomAmountInput
                        label={formik.values.currency}
                        name="balanceAmount"
                        field="Balance Amount"
                        type="text"
                        className=""
                        id="balanceAmount"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.balanceAmount || ""}
                        invalid={
                          formik.touched.balanceAmount &&
                          formik.errors.balanceAmount
                            ? true
                            : false
                        }
                        // mandatory="yes"
                      />
                    </Col> */}

                    <Col md="4">
                      <FormGroup className="mb-3">
                        <Label htmlFor="notes">Notes</Label>
                        <Input
                          name="notes"
                          type="textarea"
                          className="form-control"
                          id="notes"
                          value={formik.values.notes || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.notes && formik.errors.notes
                              ? true
                              : false
                          }
                        />
                        {formik.touched.notes && formik.errors.notes ? (
                          <FormFeedback type="invalid">
                            {formik.errors.notes}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer save={formik.handleSubmit} />
    </div>
  );
}

export default AddReceivables;